import { JSX } from 'react'


import { Center, Spinner, CenterProps } from '@chakra-ui/react'



// eslint-disable-next-line @typescript-eslint/naming-convention
export function Default
(props: CenterProps): JSX.Element
{
	return (
		<Center h="full" {...props}>
			<Spinner size="sm" color="blue.200" />

		</Center>

	)

}
